import * as Actions from './actions';
import make from './graph/make/make';

/**
 * @param {Object} snapshot
 * @param {Object} mutation
 * @returns
 */
export default function mutate(snapshot, mutation) {
  console.time('Snapshots.useSnapshot.mutate');
  const mutated = make(snapshot);

  const { entities, ...update } = mutation;
  for (const key in update) {
    mutated[key] = update[key];
  }

  if (entities) {
    for (const plural in entities) {
      for (const action in entities[plural]) {
        for (const input of entities[plural][action]) {
          Actions[action](plural, mutated, input);
        }
      }
    }
  }

  console.timeEnd('Snapshots.useSnapshot.mutate');
  return mutated;
}
